import React from 'react';
import styled from 'styled-components';

class Footer extends React.Component {
  render() {
    const Bloque = styled.div`
      display: block;
      margin: 3em 0 1em 0;
      text-align: center !important;
    `;

    return (
      <Bloque>
        <a href={this.props.referrer.u} target="_blank">
        <p> {this.props.referrer.n} © 2018</p>
        </a>

      </Bloque>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js